import { render, staticRenderFns } from "./BlockDialog.vue?vue&type=template&id=273ec6fb&scoped=true"
import script from "./BlockDialog.vue?vue&type=script&lang=ts"
export * from "./BlockDialog.vue?vue&type=script&lang=ts"
import style0 from "./BlockDialog.vue?vue&type=style&index=0&id=273ec6fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273ec6fb",
  null
  
)

export default component.exports